import { useFormik } from "formik";
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import { environmentVariables } from "../../config/env.config";
import { OTPSchema } from "../../common/registerValidationCustomer";
import * as Yup from "yup";

const verifyOtpBank = ({ bankId, userData, closeModal, fetchBankData }) => {
    const baseUrl = environmentVariables?.apiUrl;
    const { t } = useTranslation();
    const inputRefs = Array.from({ length: 6 }, () => useRef());

    const otpSchema = Yup.object().shape({
        otp: Yup.string()
            .required("OTP is required")
            .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
            .length(6),
    });

    const handleOtpKeyDown = (e, index) => {
        if (e.key === "Backspace" && !formik.values.otp[index] && index > 0) {
            inputRefs[index - 1]?.current?.focus();
        }
    };

    const formik = useFormik({
        initialValues: {
            otp: "",
            bank_id: bankId
        },
        validationSchema: otpSchema,
        onSubmit: async (values) => {

            try {
                const response = await axios.post(`${baseUrl}api/v1/user/verifyBankDetails`, values, {
                    headers: {
                        'Content-Type': 'application/json',
                        _token: userData?.token,
                    },
                });
                toast.success(response?.data?.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                });
                closeModal();
                fetchBankData()
                formik.resetForm();

            } catch (error) {
                console.error('Error ', error);
                toast.error(error?.response?.data?.message || error?.message, {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000,
                });
            }

        },
        enableReinitialize: true,
    });
    return (
        <>
            <div className="bankOtpPopup">
                <div className="modal-content">
                    <form onSubmit={formik.handleSubmit}>
                        <div className="form-section" style={{ paddingTop: "30px", textAlign: "center" }}>
                            <h3 className="innercreatetitle">{t("Enter_verification_code")}</h3>
                            <div className="login-inner-form" style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <input
                                        key={index}
                                        className="square-input"
                                        maxLength="1"
                                        value={formik.values.otp[index] || ""}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/[^0-9]/g, "");
                                            const otpArray = formik.values.otp.split("");
                                            otpArray[index] = val;
                                            formik.setFieldValue("otp", otpArray.join("").slice(0, 6));
                                            if (val && index < 5) {
                                                inputRefs[index + 1]?.current?.focus();
                                            }
                                        }}
                                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                        ref={inputRefs[index]}
                                    />
                                ))}
                            </div>
                            {formik.errors.otp && formik.touched.otp && (
                                <div style={{ color: "red", marginTop: "10px" }}>{formik.errors.otp}</div>
                            )}
                        </div>

                        <div className="form-group" style={{ margin: "0 auto", maxWidth: "300px", width: "100%", marginBottom: "20px" }}>
                            <button
                                type="submit"
                                className="btn-theme login_button"
                                disabled={formik.isSubmitting}
                                style={{ width: "100%" }}
                            >
                                {!formik.isSubmitting ? t("Submit") : <CircularLoader size={20} />}
                            </button>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={() => {
                                    formik.resetForm();
                                    closeModal();
                                }}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "10px",
                                    zIndex: "10"
                                }}
                            ></button>
                        </div>
                    </form>
                </div>

            </div>
        </>
    );
};


export default verifyOtpBank

